import { supabase } from '../lib/supabase';

/** True if signed-in user's email appears in Supabase admin_users (RLS: user may read only their row). */
export async function isUserListedAdmin(email: string | undefined | null): Promise<boolean> {
  if (!supabase || !email) return false;
  // Must match JWT email casing used in RLS: admin_users.email = auth.jwt() ->> 'email'
  const normalized = email.trim();
  const { data, error } = await supabase
    .from('admin_users')
    .select('email')
    .eq('email', normalized)
    .maybeSingle();

  if (error) {
    console.error('Admin check failed:', error);
    return false;
  }
  return !!data;
}
